import { createSlice } from "@reduxjs/toolkit";
import { AppThunk } from "../store/configureStore";
import UrlService from "Services/urlFetch";
import { toast } from "react-toastify";
import I18n from "../Services/i18n";
import { IUrlData } from "../types/url";

interface IUrlBody {
  url: string;
}

interface IUrlState {
  loading: boolean;
  data: IUrlData;
  errors: any;
}

const initialState: IUrlState = {
  loading: false,
  data: {} as IUrlData,
  errors: {},
};

const urlSlice = createSlice({
  name: "urlFetch",
  initialState,
  reducers: {
    setLoader: (state) => {
      state.loading = true;
      state.errors = initialState.errors;
    },
    setData: (state, action) => {
      const { payload } = action;
      state.loading = false;
      state.data = payload;
    },
    setError: (state, action) => {
      const { payload } = action;
      state.loading = false;
      state.errors = payload;
    },
  },
});

export const { setLoader, setData, setError } = urlSlice.actions;

export const getRssParts = (body: IUrlBody): AppThunk => async (dispatch) => {
  dispatch(setLoader());
  try {
    const response = await UrlService.fetchRSS(body);
    if (!response.title?.length) {
      dispatch(
        setError({
          title: "Something  get wrong",
          message: "Title of response is empty",
        })
      );
    } else {
      dispatch(setData(response));
    }
  } catch (error) {
    dispatch(setError(error));
  }
};

export const getUrlParts = (link: string): AppThunk => async (dispatch) => {
  dispatch(setLoader());
  try {
    const response = await UrlService.fetchURL(link);
    dispatch(setData(response));
  } catch (error) {
    dispatch(setError(error));
    toast.error(I18n.getStringByKey("error_something-goes-wrong"));
  }
};
export default urlSlice.reducer;
